import { render } from "./TicketCorpCard.vue?vue&type=template&id=3a2cb014"
import script from "./TicketCorpCard.vue?vue&type=script&lang=js"
export * from "./TicketCorpCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__